// 导航菜单功能
class NavMenuController {
  // 菜单类型映射
  menuTypeMap = {
    main: "main", // 主菜单
    services: "services", // 服务类菜单
  };
  // 导航菜单数据
  navMenuData = {};
  // 当前选中的一级菜单
  activeMenuItem = null;
  // 当前选中的二级菜单
  activeSubMenuItem = null;
  // 导航菜单选择器
  selectors = {
    // PC导航菜单
    navMenu: "#SiteHeader .header-desktop-nav-menu",
    navDetailsContainer: ".site-nav__details", // 导航菜单详情
    navSummary: "summary.site-nav__link", // 导航菜单标题
    subMenuItem: ".site-nav__dropdown-item", // 二级菜单项
    subMenuTitle: ".site-nav__dropdown-title", // 二级菜单标题
    subMenuLink: ".site-nav__dropdown-link", // 二级菜单标题链接
    subMenuWrapper: ".site-nav__dropdown-menu-wrapper", // 二级菜单列表容器
    subMenuProductsWrapperIdPrefix: "navMenuProductsWrapper", // 二级菜单商品容器id前缀
    subMenuProductListWrapper: ".site-nav__dropdown-product-list-wrapper", // 二级菜单商品列表容器
    subMenuProductList: ".site-nav__dropdown-product-list", // 二级菜单商品列表
    subMenuViewAllLink: ".site-nav__dropdown-view-all", // 二级菜单查看更多链接
    // 移动端导航菜单
    mobileMenu: ".mobile-menu-list", // 移动端导航菜单列表
    mobileMenuItem: ".mobile-menu-item", // 移动端导航一级菜单
    mobileSubmenuContainer: ".mobile-submenu-container", // 移动端导航二级级菜单列表
    mobileSubmenuHeaderTitle: ".submenu-header-title", // 移动端导航二级级菜单头部标题
    mobileSubmenuBack: ".submenu-header-back", // 移动端导航二级级菜单头部返回
    mobileSubmenuClose: ".submenu-header-close", // 移动端导航二级级菜单头部关闭
    mobileSubmenuContent: ".mobile-submenu-content", // 移动端导航二级级菜单内容
    mobileSubmenuList: ".submenu-list", // 移动端导航二级级菜单列表
    submenuCollapseItem: ".submenu-collapse-item", // 折叠菜单
    submenuCollapseItemHeader: ".submenu-collapse-item-header", // 折叠菜单头部
    submenuCollapseItemContent: ".submenu-collapse-item-content", // 折叠菜单内容
    submenuCollapseItemInner: ".submenu-collapse-item-inner", // 折叠菜单内容
    submenuCollapseItemFooter: ".submenu-collapse-item-footer", // 折叠菜单底部按钮
    mobileServicesSubmenuItem: ".services-submenu-item", // 移动端服务类菜单商品列表
  };
  // 菜单数据 sessionStorage key
  menuDataSessionStorageKey = "VOGRACE_MENUS";

  constructor() {
    this.init();
  }

  init() {
    this.initNavMenuListener();
    this.fetchNavMenuData();
  }

  // 获取菜单数据接口参数，增加flag参数用于强制更新接口
  getFetchMenuParamsString() {
    const lang = this.getLanguage();
    const isForceUpdateMenu =
      localStorage.getItem("VOGRACE_FORCE_UPDATE_MENU") === "1";
    const currentMenuHandle =
      window.VOGRACE_HEADER_CURRENT_MENU_HANDLE || "main-menu";

    const params = new URLSearchParams();

    params.set("lang", lang);
    params.set("handle", currentMenuHandle);

    if (isForceUpdateMenu) {
      params.set("flag", 1);
    }

    return params.toString();
  }

  /** 获取当前语言 */
  getLanguage() {
    return document.documentElement.lang || 'en';
  }

  // 设置菜单数据到sessionStorage
  setSessionStorageMenusData(menusData) {
    sessionStorage.setItem(this.menuDataSessionStorageKey, JSON.stringify(menusData));
  }

  // 从sessionStorage获取菜单数据
  getSessionStorageMenusData() {
    return JSON.parse(sessionStorage.getItem(this.menuDataSessionStorageKey));
  }

  // 获取导航菜单数据
  async fetchNavMenuData() {
    const lang = this.getLanguage();
    
    // 先从sessionStorage获取菜单数据
    const sessionMenusData = this.getSessionStorageMenusData();
    // 有缓存，并且缓存的语言与当前语言一致，则直接使用缓存数据
    if (sessionMenusData && sessionMenusData.lang === lang) {
      this.navMenuData = sessionMenusData;
      this.initDesktopNavMenuProducts();
      this.initMobileSubMenu();
      this.toggleLoading(false);
      return;
    }

    const paramsString = this.getFetchMenuParamsString();
    // 当前导航菜单的 handle（区别于菜单名称，handle是菜单的唯一标识）
    const currentMenuHandle = window.VOGRACE_HEADER_CURRENT_MENU_HANDLE;
    const apiHost = VogUtils.getApiHost();
    const url = `${apiHost}/menus?${paramsString}`;
    const res = await fetch(url).then((res) => res.json());

    if (res && res.data && Object.keys(res.data).length > 0) {
      // 关闭loading
      this.toggleLoading(false);

      const mainMenuData = res.data.find(
        (item) => item.handle === currentMenuHandle
      );
      if (mainMenuData) {
        // 将当前语言设置到菜单数据中，用于后续切换预言时，清空缓存
        mainMenuData.lang = lang;
        this.navMenuData = mainMenuData;

        this.initDesktopNavMenuProducts();
        this.initMobileSubMenu();

        // 设置菜单数据到sessionStorage
        this.setSessionStorageMenusData(mainMenuData);
      }
    }
  }

  // 初始化PC导航菜单商品
  initDesktopNavMenuProducts() {
    // 数据未获取到之前，已经选中了导航菜单项，则渲染导航菜单商品
    if (this.activeSubMenuItem) {
      this.renderDesktopMenuProducts();
    } else {
      // 加载数据后，默认选中第一个标题项
      const navDetailsContainer = document.querySelectorAll(
        this.selectors.navDetailsContainer
      );
      navDetailsContainer.forEach((navDetail) => {
        // 找到打开的导航菜单
        if (navDetail.hasAttribute("open")) {
          const link = navDetail.querySelectorAll(
            `.h5.site-nav__dropdown-item ${this.selectors.subMenuLink}`
          )[0];
          // 默认渲染标题项下的商品列表
          if (link) {
            // 处理菜单hover状态
            this.handleDesktopMenuHoverStatus(link);
            // 找到当前选中的导航菜单项
            this.findDesktopActiveMenuItem(link);
            // 渲染导航菜单商品
            this.renderDesktopMenuProducts(navDetail);
          }
        }
      });
    }
  }

  // 用于接口数据返回后，初始化移动端导航二级菜单
  initMobileSubMenu() {
    // 如果当前选中的菜单项存在，则渲染移动端导航二级菜单
    if (this.activeMenuItem) {
      const { menuType } = this.activeMenuItem;
      // 服务类菜单，则不渲染移动端导航二级菜单
      // 因为服务类菜单的二级菜单数据来源不走接口，走shopify的配置
      if (menuType == this.menuTypeMap.services) {
        return;
      }

      this.renderMobileSubMenu();
    }
  }

  // 初始化导航菜单监听事件
  initNavMenuListener() {
    // 监听PC导航hover事件
    this.desktopNavMenuHoverListener();
    // 监听导航菜单相关事件
    this.desktopDropdownMenuListener();
    // 监听移动端导航菜单相关事件
    this.mobileDrawerMenuListener();
    // 监听移动端导航菜单折叠事件
    this.mobileSubmenuCollapseListener();
  }

  // PC渲染当前下拉菜单中被hover的商品数据
  renderDesktopMenuProducts(targetContainer) {
    if (!this.activeMenuItem || !this.activeSubMenuItem) {
      return;
    }

    targetContainer = targetContainer || document;

    const products = this.findActiveMenuProducts();
    const { index: navIndex } = this.activeMenuItem;

    // 设置 view all 的链接
    const viewAllLink = targetContainer.querySelector(
      `#${this.selectors.subMenuProductsWrapperIdPrefix}-${navIndex + 1} ${
        this.selectors.subMenuViewAllLink
      }`
    );
    if (viewAllLink) {
      viewAllLink.href = this.activeSubMenuItem.url;
    }

    // 渲染当前 hover submenu 项的商品列表
    const subMenuProductList = targetContainer.querySelector(
      `#${this.selectors.subMenuProductsWrapperIdPrefix}-${navIndex + 1} ${
        this.selectors.subMenuProductList
      }`
    );
    if (subMenuProductList) {
      subMenuProductList.innerHTML = "";
      const productItems = products
        .map((product) => {
          const { url, title, imageUrl } = this.formatProductData(product);

          return `
          <a class="product-item" href="${url}">
            <div class="product-item-image">
              <img src="${imageUrl}" alt="${title}">
            </div>
            <div class="product-item-title text-ellipsis-line3">${title}</div>
          </a>
        `;
        })
        .join("");

      subMenuProductList.innerHTML = productItems;
    }
  }

  // 渲染移动端导航二级级菜单
  renderMobileSubMenu(menuType, submenuType) {
    if (!this.activeMenuItem) return;

    // 设置二级菜单一些状态class
    this.toggleMobileSubmenuClass(menuType, submenuType);

    // 设置移动端导航二级级菜单头部标题
    const { title: menuTitle } = this.activeMenuItem;
    const submenuHeaderTitle = document.querySelector(
      this.selectors.mobileSubmenuHeaderTitle
    );
    if (submenuHeaderTitle) {
      submenuHeaderTitle.innerHTML = menuTitle;
    }

    // 渲染移动端导航二级级菜单列表
    const menu = this.findActiveMenu();
    if (!menu) return;

    const submenus = (menu.items || []).slice(0);
    const submenuList = document.querySelector(
      this.selectors.mobileSubmenuList
    );
    if (submenuList) {
      submenuList.innerHTML = submenus
        .map((submenu) => {
          const { title, products = [], url } = submenu;

          if (products.length === 0) {
            return `
              <div class="submenu-collapse-item">
                <div class="submenu-collapse-item-header" data-href="${url}">
                  ${title}
                </div>
              </div>
            `;
          }

          return `
          <div class="submenu-collapse-item">
            <div class="submenu-collapse-item-header">
              <div class="submenu-collapse-item-title">${title}</div>
              <div class="submenu-collapse-item-arrow">
                <svg class="iconfont" aria-hidden="true">
                  <use xlink:href="#icon-down"></use>
                </svg>
              </div>
            </div>
            <div class="submenu-collapse-item-content">
              <div class="submenu-collapse-item-inner">
                <div class="submenu-collapse-item-product-list">
                  ${products
                    .map((product) => {
                      const { title, url, imageUrl } =
                        this.formatProductData(product);
                      return `
                      <a class="product-item" href="${url}">
                        <div class="product-item-image">
                          <img src="${imageUrl}" alt="${title}">
                        </div>
                        <div class="product-item-title text-ellipsis-line3">${title}</div>
                      </a>
                    `;
                    })
                    .join("")}
                </div>
                <div class="submenu-collapse-item-footer">
                  <div class="submenu-collapse-item-arrow">+</div>
                  <a class="submenu-collapse-item-view-all" href="${url}">View more</a>
                </div>
              </div>
            </div>
          </div>
        `;
        })
        .join("");
    }

    document
      .querySelector(".mobile-submenu-footer")
      .querySelector(".submenu-footer-view-all")
      .setAttribute("href", menu.url);
  }

  /**
   * 渲染移动端 服务类 二级菜单
   * @param {string} menuType 一级菜单类型："main"、"services"
   * @param {string} submenuType 二级菜单类型："activity"、"member_center"
   */
  renderMobileServicesSubMenu(menuType, submenuType) {
    if (!this.activeMenuItem) return;

    this.toggleMobileSubmenuClass(menuType, submenuType);

    // 设置移动端导航二级级菜单头部标题
    const { title: menuTitle, url } = this.activeMenuItem;
    const submenuHeaderTitle = document.querySelector(
      this.selectors.mobileSubmenuHeaderTitle
    );
    if (submenuHeaderTitle) {
      submenuHeaderTitle.innerHTML = menuTitle;
    }
    const $viewall = window.VOGRACE.$('a[class="submenu-footer-view-all"]');
    $viewall.setAttribute("href", url);
  }

  // PC监听下拉二级菜单相关事件
  desktopDropdownMenuListener() {
    const navMenu = document.querySelectorAll(this.selectors.navMenu);

    // 给下拉菜单添加hover效果
    navMenu.forEach((navMenu) => {
      const dropdownMenuLinks = navMenu.querySelectorAll(
        `.h5.site-nav__dropdown-item ${this.selectors.subMenuLink}`
      );
      if (dropdownMenuLinks.length) {
        dropdownMenuLinks.forEach((subMenuLink) => {
          subMenuLink.addEventListener("mouseover", (event) => {
            const target = event.target;

            if (target.classList.contains("hover-background")) {
              return;
            }

            const targetContainer = target.closest(
              this.selectors.navDetailsContainer
            );

            // 处理下拉菜单的菜单项hover状态
            this.handleDesktopMenuHoverStatus(target);
            // 找到当前选中的菜单项
            this.findDesktopActiveMenuItem(target);
            // 渲染导航下拉菜单商品
            this.renderDesktopMenuProducts(targetContainer);
          });
        });
      }
    });
  }

  // PC监听一级菜单的hover事件
  desktopNavMenuHoverListener() {
    const navSummaries = document.querySelectorAll(this.selectors.navSummary);

    navSummaries.forEach((summary) => {
      const navDetailsContainer = summary.closest(
        this.selectors.navDetailsContainer
      );
      // 监听导航菜单focusin事件
      summary.addEventListener("focusin", () => {
        // 延迟300ms，确保导航菜单已经打开
        setTimeout(() => {
          // hover一级菜单时，默认渲染第一个二级菜单商品列表
          this.initDesktopNavMenuProducts();
        }, 300);
      });

      navDetailsContainer.addEventListener("focusout", () => {
        this.activeMenuItem = null;
        this.activeSubMenuItem = null;
      });

      // 监听导航菜单mouseover事件
      summary.addEventListener("mouseover", () => {
        // 延迟300ms，确保导航菜单已经打开
        setTimeout(() => {
          // hover一级菜单时，默认渲染第一个二级菜单商品列表
          this.initDesktopNavMenuProducts();
        }, 300);
      });

      navDetailsContainer.addEventListener("mouseleave", () => {
        this.activeMenuItem = null;
        this.activeSubMenuItem = null;
      });
    });
  }

  // 移动端监听导航菜单相关事件
  mobileDrawerMenuListener() {
    const mobileMenu = document.querySelectorAll(this.selectors.mobileMenu);

    // 点击一级菜单跳转二级菜单列表
    mobileMenu.forEach((menu) => {
      menu.addEventListener("click", (event) => {
        const menuItem = event.target.closest(this.selectors.mobileMenuItem);
        const { hasDropdown, menuType, submenuType } = menuItem.dataset;

        // 没有下拉菜单的菜单项，一般都是a标签直接跳转
        if (!hasDropdown) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        // 服务类菜单走shopify的配置，需要特殊处理
        if (menuType === this.menuTypeMap.services) {
          this.findMobileActiveMenuItem(event.target);
          this.renderMobileServicesSubMenu(menuType, submenuType);
          this.toggleMobileSubmenuVisibility(true);
        } else {
          this.findMobileActiveMenuItem(event.target);
          this.renderMobileSubMenu(menuType);
          this.toggleMobileSubmenuVisibility(true);
        }
      });
    });

    // 二级菜单列表关闭
    const mobileSubmenuClose = document.querySelectorAll(
      this.selectors.mobileSubmenuClose
    );
    mobileSubmenuClose.forEach((close) => {
      close.addEventListener("pointerdown", (event) => {
        setTimeout(() => {
          this.toggleMobileSubmenuVisibility(false);
          this.activeMenuItem = null;
          this.activeSubMenuItem = null;
          // 延迟400ms，确保Drawer动画完成后，再关闭
        }, 400);
      });
    });

    // 二级菜单列表返回
    const mobileSubmenuBack = document.querySelectorAll(
      this.selectors.mobileSubmenuBack
    );
    mobileSubmenuBack.forEach((back) => {
      back.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.toggleMobileSubmenuVisibility(false);
        this.activeMenuItem = null;
        this.activeSubMenuItem = null;
      });
    });
  }

  // 移动端监听导航菜单折叠事件
  mobileSubmenuCollapseListener() {
    const submenuList = document.querySelectorAll(
      this.selectors.mobileSubmenuList
    );
    submenuList.forEach((submenu) => {
      submenu.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const target = event.target;
        const item = target.closest(this.selectors.submenuCollapseItem);
        const header = target.closest(this.selectors.submenuCollapseItemHeader);

        if (target.closest(this.selectors.submenuCollapseItemFooter)) {
          window.location.href = target.href;
          return;
        }

        const productItem = target.closest(".product-item");
        if (productItem) {
          window.location.href = productItem.href;
          return;
        }

        if (header) {
          const href = header.dataset.href;
          if (href) {
            window.location.href = href;
            return;
          }

          const next = header.nextElementSibling;
          const siblings = this.getSiblings(item);
          const inner = next.querySelector(
            this.selectors.submenuCollapseItemInner
          );
          const height = inner.offsetHeight;
          const expanded = item.classList.contains("expand");

          // 展开/收起目标元素
          if (expanded) {
            next.style.height = "0px";
            item.classList.remove("expand");
          } else {
            // 移除其他兄弟元素的展开状态
            siblings.forEach((siblingCollapseItem) => {
              // 1. 移除兄弟元素的展开状态
              siblingCollapseItem.classList.remove("expand");
              // 2. 设置兄弟元素的高度为0
              const siblingContent = siblingCollapseItem.querySelector(
                this.selectors.submenuCollapseItemContent
              );
              if (siblingContent) {
                siblingContent.style.height = "0px";
              }
            });

            next.style.height = `${height}px`;
            item.classList.add("expand");
          }
        }
      });
    });
  }

  /**
   * PC处理导航下拉菜单hover状态
   * @param {Element} target 目标元素
   */
  handleDesktopMenuHoverStatus(target) {
    if (!target) return;

    // hover的样式类型，灰色背景块、下划线
    const hoverType = target.closest(this.selectors.subMenuWrapper).dataset
      .hoverType;

    // 移除兄弟元素的hover效果
    const siblings = this.getSiblings(
      target.closest(this.selectors.subMenuItem)
    );
    siblings.forEach((sibling) => {
      const siblingLink = sibling.querySelector(this.selectors.subMenuLink);
      if (siblingLink) {
        siblingLink.classList.remove("hover-background", "hover-underline");
      }
    });

    // 给元素添加hover效果
    target.classList.add(hoverType);
  }

  /**
   * 移动端设置导航二级级菜单的显示/隐藏状态
   * @param {boolean} show 是否显示
   */
  toggleMobileSubmenuVisibility(show = false) {
    const mobileSubmenuContainer = document.querySelector(
      this.selectors.mobileSubmenuContainer
    );
    if (mobileSubmenuContainer) {
      mobileSubmenuContainer.classList.toggle("show-submenu", show);
      // DOM先显示，然后通过css3动画显示
      setTimeout(() => {
        mobileSubmenuContainer.style.opacity = show ? 1 : 0;
      }, 0);
    }
  }

  /**
   * 移动端设置导航二级级菜单的class
   * @param {string} menuType 一级菜单类型："main"、"services"
   * @param {string} submenuType 二级菜单类型："activity"、"member_center"
   */
  toggleMobileSubmenuClass(menuType, submenuType) {
    const submenuContainer = document.querySelector(
      this.selectors.mobileSubmenuContainer
    );
    if (submenuContainer) {
      // 标记当前选中的菜单类型
      if (menuType) {
        submenuContainer.dataset.activeMenuType = menuType;
      } else {
        submenuContainer.removeAttribute("data-active-menu-type");
      }

      // 标记当前选中的二级菜单类型
      if (submenuType) {
        submenuContainer.dataset.activeSubmenuType = submenuType;
      } else {
        submenuContainer.removeAttribute("data-active-submenu-type");
      }

      // 点击服务类菜单时，判断当前显示哪个服务类的二级菜单
      const mobileServicesSubmenuItems = submenuContainer.querySelectorAll(
        this.selectors.mobileServicesSubmenuItem
      );
      mobileServicesSubmenuItems.forEach((submenuItem) => {
        const { submenuType: itemSubmenuType } = submenuItem.dataset;
        if (itemSubmenuType === submenuType) {
          submenuItem.classList.add("active-submenu");
        } else {
          submenuItem.classList.remove("active-submenu");
        }
      });
    }
  }

  /**
   * 移动端设置导航二级级菜单的loading状态
   * @param {boolean} show 是否显示loading状态
   */
  toggleLoading(show = false) {
    const productListWrapper = [
      ...document.querySelectorAll(this.selectors.subMenuProductListWrapper),
      ...document.querySelectorAll(this.selectors.mobileSubmenuContent),
    ];

    productListWrapper.forEach((productListWrapper) => {
      productListWrapper.classList.toggle("show-loading", show);
    });
  }

  // 移动端查找选中的一级菜单项
  findMobileActiveMenuItem(target) {
    const menuItem = target.closest(this.selectors.mobileMenuItem);
    if (menuItem) {
      const {
        hasDropdown,
        menuIndex,
        menuTitle,
        linkUrl,
        menuType,
        submenuType,
      } = menuItem.dataset;
      if (hasDropdown) {
        this.activeMenuItem = {
          index: menuIndex - 1,
          title: menuTitle,
          url: linkUrl,
          menuType,
          submenuType,
        };
      }
    }
  }

  // PC找到当前选中的导航菜单
  findDesktopActiveMenuItem(target) {
    // 获取当前选中的导航菜单项 dataset 和 href 等数据
    const linkUrl = target.href;
    const dataset = target.dataset;
    const navMenuIndexArray = (dataset.navMenuIndex || "").split("-");

    const navIndex = Number(navMenuIndexArray[0]);
    const navTitle = dataset.navTitle;
    const menuIndex = Number(navMenuIndexArray[1]);
    const menuTitle = dataset.menuTitle;

    this.activeMenuItem = {
      index: navIndex - 1,
      title: navTitle,
    };
    this.activeSubMenuItem = {
      index: menuIndex,
      title: menuTitle,
      url: linkUrl,
    };
  }

  // 查找当前选中的一级菜单数据
  findActiveMenu() {
    if (!this.activeMenuItem) return;

    const { index: menuIndex } = this.activeMenuItem;
    const menus = this.navMenuData.items || [];
    const activeMenu = menus.find((menu, index) => index === menuIndex);
    if (activeMenu) {
      return activeMenu;
    }
  }

  // 查找当前选中的 一级 ——> 二级 菜单下的商品数据
  findActiveMenuProducts() {
    const menu = this.findActiveMenu();
    if (!menu) {
      return [];
    }

    const { index: submenuIndex } = this.activeSubMenuItem;
    const submenus = menu.items || [];
    let activeProducts = [];

    // 子标题菜单的商品数据
    if (submenuIndex === 0) {
      activeProducts = menu.products || [];
    } else {
      const activeSubmenu = submenus.find(
        (submenu, index) => index === submenuIndex - 1
      );
      if (activeSubmenu) {
        activeProducts = activeSubmenu.products || [];
      }
    }

    // 最多取四个
    return activeProducts.slice(0, 4);
  }

  // 格式化商品数据
  formatProductData(product) {
    const title = product.title || "";
    // onlineStoreUrl生产环境会有数据，onlineStorePreviewUrl测试环境会有数据
    // 优先取onlineStoreUrl
    const url = product.onlineStoreUrl || product.onlineStorePreviewUrl;
    // 暂时不显示价格
    // const { minPrice, maxPrice } = this.getProductPrice(product);

    return {
      title,
      url,
      imageUrl: this.getProductImageUrl(product),
      // minPrice,
      // maxPrice,
    };
  }

  // 获取商品图片url
  getProductImageUrl(product) {
    try {
      // return product.media.nodes[0].preview.image.url;
      return product.image;
    } catch (error) {
      console.error("Get product image url error: ", error, "\n", product);
      return "";
    }
  }

  // 获取商品价格
  getProductPrice(product) {
    let minPrice = "";
    let maxPrice = "";
    let currencyCode = "CNY";

    try {
      minPrice = product.priceRangeV2.minVariantPrice.amount;
      maxPrice = product.priceRangeV2.maxVariantPrice.amount;
      currencyCode = product.priceRangeV2.minVariantPrice.currencyCode;
    } catch (error) {
      console.error("Get product price error: ", error, "\n", product);
    }

    return {
      minPrice,
      maxPrice,
      currencyCode,
    };
  }

  getSiblings(element) {
    return Array.from(element.parentElement.children).filter(
      (el) => el !== element
    );
  }
}

VogUtils.DOMready(() => {
  new NavMenuController();
});
